var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.node.parameters, function(param, index) {
        return [
          _c(
            "div",
            {
              key: `input-${index}`,
              staticClass: "cf-node-properties__field",
              class: {
                "display-flex": param.name === "hourseOfOperationSetting"
              }
            },
            [
              _c(
                "label",
                {
                  staticClass: "control-label",
                  class: {
                    "m-b-0 m-t-5": param.name === "hourseOfOperationSetting"
                  }
                },
                [
                  _vm._v("\n        " + _vm._s(param.displayName) + " "),
                  !param.isOptional ? _c("span", [_vm._v("*")]) : _vm._e(),
                  _vm._v(" "),
                  _c("i", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip.top",
                        value: param.description,
                        expression: "param.description",
                        modifiers: { top: true }
                      }
                    ],
                    staticClass: "fa fa-question-circle m-l-5",
                    attrs: { "aria-hidden": "true" }
                  })
                ]
              ),
              _vm._v(" "),
              param.name === "timeZoneId"
                ? _c("InputSearchableSelect", {
                    attrs: {
                      config: _vm.timeZoneOptions,
                      required: !param.isOptional,
                      error: _vm.getFieldError(_vm.propertyErrors, param.name)
                    },
                    on: {
                      input: function($event) {
                        return _vm.inputChange(param.name, $event)
                      }
                    },
                    model: {
                      value: _vm.settingsCopy[param.name],
                      callback: function($$v) {
                        _vm.$set(_vm.settingsCopy, param.name, $$v)
                      },
                      expression: "settingsCopy[param.name]"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              param.name === "hourseOfOperationSetting"
                ? _c("MultipleToggle", {
                    staticClass:
                      "cf-node-properties__field-btn-group cf-node-properties__multiple-toggle-setting",
                    attrs: {
                      value: _vm.hoursType,
                      options: _vm.hoursTypeOptions
                    },
                    on: {
                      onToggle: function($event) {
                        return _vm.hoursTypeChange($event)
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          param.name === "hourseOfOperationSetting"
            ? [
                _vm.getFieldError(_vm.propertyErrors, "hoursOfOperationSetting")
                  ? _c(
                      "div",
                      {
                        key: `errors-${index}`,
                        staticClass: "cf-node-properties__input-error m-b-10"
                      },
                      [
                        _vm._v(
                          "\n        Hours of operation must be set below.\n      "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.hoursType === "basic"
                  ? [
                      _c(
                        "div",
                        {
                          key: `basic-${index}`,
                          staticClass: "cf-node-properties__hours-filter-day"
                        },
                        [
                          _c("HoursFilterTimeValues", {
                            attrs: {
                              "hours-type": _vm.hoursType,
                              "open-time":
                                _vm.hoursOfOperationValues[0].openTime.time,
                              "close-time":
                                _vm.hoursOfOperationValues[0].closeTime.time
                            },
                            on: {
                              "update:openTime": function($event) {
                                return _vm.$set(
                                  _vm.hoursOfOperationValues[0].openTime,
                                  "time",
                                  $event
                                )
                              },
                              "update:open-time": function($event) {
                                return _vm.$set(
                                  _vm.hoursOfOperationValues[0].openTime,
                                  "time",
                                  $event
                                )
                              },
                              "update:closeTime": function($event) {
                                return _vm.$set(
                                  _vm.hoursOfOperationValues[0].closeTime,
                                  "time",
                                  $event
                                )
                              },
                              "update:close-time": function($event) {
                                return _vm.$set(
                                  _vm.hoursOfOperationValues[0].closeTime,
                                  "time",
                                  $event
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "cf-node-properties__hours-filter-breaks-wrapper",
                              attrs: { id: "breaksDay0" }
                            },
                            [
                              _c("HoursFilterBreakForm", {
                                on: {
                                  addBreak: function($event) {
                                    return _vm.addBreak($event.timeBreak, 0)
                                  },
                                  toggleBreakForm: function($event) {
                                    return _vm.toggleBreakForm($event, 0)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm.hoursOfOperationValues[0].breaks &&
                              _vm.hoursOfOperationValues[0].breaks.length
                                ? _c("HoursFilterBreaks", {
                                    attrs: {
                                      breaks:
                                        _vm.hoursOfOperationValues[0].breaks
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.hoursType === "advanced"
                  ? _vm._l(_vm.hoursOfOperationValues, function(
                      hours,
                      dayIndex
                    ) {
                      return _c(
                        "div",
                        {
                          key: `day-${index}-${dayIndex}`,
                          staticClass: "cf-node-properties__hours-filter-day"
                        },
                        [
                          _c("HoursFilterTimeValues", {
                            attrs: {
                              "hours-type": _vm.hoursType,
                              "is-open": hours.isOpen,
                              "open-time": hours.openTime.time,
                              "close-time": hours.closeTime.time,
                              day: _vm.days[dayIndex],
                              disabled: !hours.isOpen
                            },
                            on: {
                              "update:isOpen": function($event) {
                                return _vm.$set(hours, "isOpen", $event)
                              },
                              "update:is-open": function($event) {
                                return _vm.$set(hours, "isOpen", $event)
                              },
                              "update:openTime": function($event) {
                                return _vm.$set(hours.openTime, "time", $event)
                              },
                              "update:open-time": function($event) {
                                return _vm.$set(hours.openTime, "time", $event)
                              },
                              "update:closeTime": function($event) {
                                return _vm.$set(hours.closeTime, "time", $event)
                              },
                              "update:close-time": function($event) {
                                return _vm.$set(hours.closeTime, "time", $event)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "cf-node-properties__hours-filter-breaks-wrapper",
                              attrs: { id: `breaksDay${dayIndex}` }
                            },
                            [
                              _c("HoursFilterBreakForm", {
                                attrs: { index: dayIndex },
                                on: {
                                  addBreak: function($event) {
                                    return _vm.addBreak(
                                      $event.timeBreak,
                                      dayIndex
                                    )
                                  },
                                  toggleBreakForm: function($event) {
                                    return _vm.toggleBreakForm($event, dayIndex)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              hours.breaks && hours.breaks.length
                                ? _c("HoursFilterBreaks", {
                                    attrs: { breaks: hours.breaks }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    })
                  : _vm._e()
              ]
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }